import styles from './FilterCardList.module.scss';

import { useEventCallback } from '@mui/material/utils';
import { Column } from '@tanstack/react-table';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterType, usePrepareFilters } from '@work4all/components';
import { IFilterPickerConfig } from '@work4all/components/lib/components/entity-picker/components/list-entity-picker';
import { EnumEntityLikePicker } from '@work4all/components/lib/components/entity-picker/enum-picker/EnumEntityLikePicker';
import { AppointmentBillableFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/appointment-billable-filter-card/AppointmentBillableFilterCard';
import { AppointmentStateFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/appointment-status-filter-card/AppointmentStatusFilterCard';
import { ArticleKindFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/article-kind-filter-kind/ArticleKindFilterCard';
import { BooleanFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/boolean-filter-card/BooleanFilterCard';
import { BusinessPartnerFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/business-partner-filter-card/BusinessPartnerFilterCard';
import { BusinessPartnerGroupFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/business-partner-group-filter-card/BusinessPartnerGroupFilterCard';
import { CategoryAssignmentFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/category-assignment-filter-card/CategoryAssignmentFilterCard';
import { ClosedStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/ClosedStatusFilterCard/ClosedStatusFilterCard';
import { ContactFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/contact-filter-card/ContactFilterCard';
import { CostCenterFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/cost-center-filter-card/CostCenterFilterCard';
import { CustomerFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/customer-filter-card/CustomerFilterCard';
import { DateFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/date-filter-card/DateFilterCard';
import { getTimeSpanUnit } from '@work4all/components/lib/dataDisplay/basic-table/components/date-range-picker/DateRangePicker';
import { DueDateClassifiedFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/due-date-classified-filter-card/DueDateClassifiedFilterCard';
import { EInvoiceFormatFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/e-invoice-format-filter-card/EInvoiceFormatFilterCard';
import { EmailKindFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/email-kind-filter-card/EmailKindFilterCard';
import {
  ArticleGroupFilterCard,
  CustomerGroupFilterCard,
  ProjectGroupFilterCard,
  SalesOpportunitiesGroupFilterCard,
  ServiceContractGroupFilterCard,
  SupplierGroupFilterCard,
} from '@work4all/components/lib/dataDisplay/basic-table/components/entity-group-filter-card/EntityGroupFilterCard';
import { InvoiceFormFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/invoice-form-filter-card/InvoiceFormFilterCard';
import { InvoiceKindFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/invoice-kind-filter-card/InvoiceKindFilterCard';
import { LedgerAccountKindFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/ledger-account-kind-filter-card/LedgerAccountKindFilterCard';
import { LookUpFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/look-up-filter-card/LookUpFilterCard';
import { MailAssignStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/MailAssignStatusFilterCard/MailAssignStatusFilterCard';
import { NumberFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/number-filter-card/NumberFilterCard';
import { PaymentKindFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/payment-kind-filter-card/PaymentKindFilterCard';
import { PaymentStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/paymnet-status-filter-card/PaymentStatusFilterCard';
import { PermitStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/permit-status-filter-card/PermitStatusFilterCard';
import { ProjectFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/project-filter-card/ProjectFilterCard';
import { ProjectTrafficLightStatusPickerFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/project-traffic-light-status-picker-filter-card/ProjectTrafficLightStatusPickerFilterCard';
import { RaAccountingStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/ra-accounting-status-filter-card/RaAccountingStatusFilterCard';
import { ReAccountingStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/re-accounting-status-filter-card/ReAccountingStatusFilterCard';
import { RythmStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/rythm-status-filter-card/RythmStatusFilterCard';
import { SalesOpportunitiesStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/sales-opportunities-status-filter-card/SalesOpportunitiesStatusFilterCard';
import { SearchFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/search-filter-card/SearchFilterCard';
import { SupplierFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/supplier-filter-card/SupplierFilterCard';
import { TaskPriorityFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/task-priority-filter-card/TaskPriorityFilterCard';
import { TaskStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/task-status-filter-card/TaskStatusFilterCard';
import { TicketCategory1FilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/ticket-category-1-filter-card/TicketCategory1FilterCard';
import { TicketKindFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/ticket-kind-filter-card/TicketKindFilterCard';
import { TicketPriorityFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/ticket-priority-filter-card/TicketPriorityFilterCard';
import { TicketStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/ticket-status-filter-card/TicketStatusFilterCard';
import { TravelExpensesOpenStatusCard } from '@work4all/components/lib/dataDisplay/basic-table/components/travel-expenses-open-status-card/TravelExpensesOpenStatusCard';
import { TravelReceiptsStatusCard } from '@work4all/components/lib/dataDisplay/basic-table/components/travel-receipts-status-card/TravelReceiptsStatusCard';
import { UserFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/user-filter-card/UserFilterCard';
import { VacationKindFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/vacation-kind-filter-card/VacationKindFilterCard';
import { VacationStatusFilterCard } from '@work4all/components/lib/dataDisplay/basic-table/components/vacation-status-filter-card/VacationStatusFilterCard';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { ListPageContext } from '../../../../../../../../../../containers/file-entities-lists/list-page-context';
import { settings, useSetting } from '../../../../../../../../../../settings';
import { getFilterConfig } from '../../../../../../../TableFilter';
import { FilterOverlayContext } from '../../FiltersOverlayV8';

export interface IFilterCardListProps {
  cols: Column<unknown>[];
}

function getEntityFilterCardComponent(entity: Entities | string) {
  switch (entity) {
    case Entities.user:
      return UserFilterCard;
    case Entities.project:
      return ProjectFilterCard;
    case Entities.costCenter:
      return CostCenterFilterCard;
    case Entities.lookUp:
      return LookUpFilterCard;
    case Entities.customer:
      return CustomerFilterCard;
    case Entities.supplier:
      return SupplierFilterCard;
    case Entities.ticketKind:
      return TicketKindFilterCard;
    case Entities.supplierGroup:
      return SupplierGroupFilterCard;
    case Entities.customerGroup:
      return CustomerGroupFilterCard;
    case Entities.articleGroup:
      return ArticleGroupFilterCard;
    case Entities.projectGroup:
      return ProjectGroupFilterCard;
    case Entities.businessPartner:
      return BusinessPartnerFilterCard;
    case Entities.paymentKind:
      return PaymentKindFilterCard;
    case Entities.contact:
      return ContactFilterCard;
    case Entities.group:
      return BusinessPartnerGroupFilterCard;
    case Entities.ticketCategory1:
      return TicketCategory1FilterCard;
    case 'mailAssignStatus':
      return MailAssignStatusFilterCard;
    case Entities.contractGroup:
      return ServiceContractGroupFilterCard;
    case Entities.categoryAssignment:
      return CategoryAssignmentFilterCard;
    default:
      return null;
  }
}

const warnedAboutPickerEntityTypeUsage = new Set<string>();
let warnedAboutSingleOptionUsage = false;

export const FilterCardListV8: React.FC<IFilterCardListProps> = (props) => {
  const { cols } = props;

  const { t } = useTranslation();

  const {
    table,
    filterCardExpandStates,
    listEntityType,
    setFilterCardExpandStates,
  } = useContext(FilterOverlayContext);

  const listPageContext = useContext(ListPageContext);
  const entityType = listEntityType ?? listPageContext?.entityType ?? null;

  const closedEntitiesSetting = useSetting(
    settings.hideClosedEntities({ entityType })
  );

  const setHideClosedEntitiesSetting = useEventCallback((value: boolean) => {
    closedEntitiesSetting.set(value);
  });

  // TODO This double the work already done in the top-level table component.
  // We parse the filter from the table state here again to use in in pickers
  // to enable "smart filtering". This work is now done twice. Once here and
  // once in the table component. Probably not a big deal, but it can be
  // refactored to avoid recomputing the same value here again.
  const { filter } = usePrepareFilters(
    table.getState().columnFilters,
    table.getState().sorting,
    undefined,
    entityType
  );

  function renderFixedDataFilterCard(
    filterType: FilterType,
    label: string,
    col: Column<unknown>
  ) {
    let FilterCard = null;

    switch (filterType) {
      case FilterType.TravelReceiptStatus:
        FilterCard = TravelReceiptsStatusCard;
        break;
      case FilterType.TravelExpensesOpenStatus:
        FilterCard = TravelExpensesOpenStatusCard;
        break;
      case FilterType.TicketStatus:
        FilterCard = TicketStatusFilterCard;
        break;
      case FilterType.AppointmentState:
        FilterCard = AppointmentStateFilterCard;
        break;
      case FilterType.AppointmentBillable:
        FilterCard = AppointmentBillableFilterCard;
        break;
      case FilterType.EmailKind:
        FilterCard = EmailKindFilterCard;
        break;
      case FilterType.VacationKind:
        FilterCard = VacationKindFilterCard;
        break;
      case FilterType.EInvoiceFormat:
        FilterCard = EInvoiceFormatFilterCard;
        break;
      case FilterType.TaskStatus:
        FilterCard = TaskStatusFilterCard;
        break;
      case FilterType.SalesOpportunitiesStatusPicker:
        FilterCard = SalesOpportunitiesStatusFilterCard;
        break;
      case FilterType.SalesOpportunitiesGroupPicker:
        FilterCard = SalesOpportunitiesGroupFilterCard;
        break;
      case FilterType.PaymentStatus:
        FilterCard = PaymentStatusFilterCard;
        break;
      case FilterType.InvoiceForm:
        FilterCard = InvoiceFormFilterCard;
        break;
      case FilterType.ReAccountingStatus:
        FilterCard = ReAccountingStatusFilterCard;
        break;
      case FilterType.RaAccountingStatus:
        FilterCard = RaAccountingStatusFilterCard;
        break;
      case FilterType.PermitStatus:
        FilterCard = PermitStatusFilterCard;
        break;
      case FilterType.VacationStatus:
        FilterCard = VacationStatusFilterCard;
        break;
      case FilterType.InvoiceKind:
        FilterCard = InvoiceKindFilterCard;
        break;
      case FilterType.LedgerAccountKind:
        FilterCard = LedgerAccountKindFilterCard;
        break;
      case FilterType.DueDateClassified:
        FilterCard = DueDateClassifiedFilterCard;
        break;
      case FilterType.ArticleKind:
        FilterCard = ArticleKindFilterCard;
        break;
      case FilterType.RythmStatus:
        FilterCard = RythmStatusFilterCard;
        break;
      case FilterType.TaskPriority:
        FilterCard = TaskPriorityFilterCard;
        break;
      case FilterType.TicketPriority:
        FilterCard = TicketPriorityFilterCard;
        break;
      case FilterType.Enum:
        FilterCard = EnumEntityLikePicker;
        break;
      case FilterType.ProjectTrafficLightStatus:
        FilterCard = ProjectTrafficLightStatusPickerFilterCard;
        break;
      default:
        break;
    }
    return !FilterCard ? null : (
      <FilterCard
        onExpandedChange={(val) => {
          setFilterCardExpandStates({
            ...filterCardExpandStates,
            [label]: val,
          });
        }}
        expanded={filterCardExpandStates[label]}
        value={(col.getFilterValue() as any)?.value ?? ''}
        onChange={(value) => {
          if (value === null || (Array.isArray(value) && value.length === 0)) {
            col.setFilterValue(null);
          } else {
            col.setFilterValue({
              value: value,
              filterType: col.columnDef.filterType,
            });
          }
        }}
        key={label}
        title={label}
      />
    );
  }

  function renderPickerFilter(col: Column<unknown>) {
    const label = col.columnDef.header as string;
    const filterParams = col.columnDef.filterParams;

    if (!filterParams) {
      console.warn(
        '`filterParams` object must be present in the column config when using Picker filter type.'
      );

      return null;
    }

    const { entity, multiple } = filterParams;

    if (
      multiple !== undefined &&
      multiple !== true &&
      !warnedAboutSingleOptionUsage
    ) {
      warnedAboutSingleOptionUsage = true;
      console.warn(
        `Found option \`multiple=${multiple}\`, but Picker filter cards currently only support multiple mode.`
      );
    }

    const EntityFilterCardComponent = getEntityFilterCardComponent(entity);

    if (!EntityFilterCardComponent) {
      if (!warnedAboutPickerEntityTypeUsage.has(entity)) {
        warnedAboutPickerEntityTypeUsage.add(entity);
        console.warn(
          `Picker filter for entity type "${entity}" is not configured.` +
            ` If this is a new filter, add it to the <FilterCardList> component.`
        );
      }

      return null;
    }

    const filterPickerConfig: IFilterPickerConfig | null =
      listPageContext === null
        ? null
        : {
            parentEntityType: entityType,
            field: col.id,
            filter,
          };

    return (
      <EntityFilterCardComponent
        lookupType={
          entity === Entities.lookUp
            ? col.columnDef.filterParams?.lookupType
            : undefined
        }
        key={label}
        filterConfig={getFilterConfig(filterPickerConfig)}
        title={label}
        value={(col.getFilterValue() as any)?.value ?? null}
        onChange={(value) => {
          if (value.length === 0) {
            col.setFilterValue(null);
          } else {
            col.setFilterValue({
              value: value,
              filterType: col.columnDef.filterType,
            });
          }
        }}
        expanded={filterCardExpandStates[label]}
        onExpandedChange={(val) => {
          setFilterCardExpandStates({
            ...filterCardExpandStates,
            [label]: val,
          });
        }}
        entityType={entityType}
      />
    );
  }

  return (
    <div className={styles.filterCardsWrap}>
      {cols.map((col) => {
        const label = col.columnDef.header as string;
        switch (col.columnDef.filterType) {
          case FilterType.Date:
            return (
              <DateFilterCard
                key={label}
                title={label}
                expanded={
                  filterCardExpandStates[col.columnDef.header as string] !==
                    undefined &&
                  filterCardExpandStates[col.columnDef.header as string]
                }
                onExpandedChange={(val) => {
                  setFilterCardExpandStates({
                    ...filterCardExpandStates,
                    [col.columnDef.header as string]: val,
                  });
                }}
                startDate={
                  (col.getFilterValue() as any)?.value?.startDate ?? null
                }
                endDate={(col.getFilterValue() as any)?.value?.endDate ?? null}
                onDelete={() => {
                  col.setFilterValue(null);
                }}
                onChange={(startDate, endDate) => {
                  if (startDate === null && endDate === null) {
                    col.setFilterValue(null);
                    return;
                  }

                  col.setFilterValue({
                    value: {
                      startDate: startDate ? startDate : undefined,
                      endDate: endDate ? endDate : undefined,
                      span: getTimeSpanUnit(startDate, endDate),
                    },
                    filterType: col.columnDef.filterType,
                  });
                }}
                {...col.columnDef.filterParams}
              />
            );
          case FilterType.Number:
            return (
              <NumberFilterCard
                key={label}
                title={label}
                expanded={
                  filterCardExpandStates[col.columnDef.header as string] !==
                    undefined &&
                  filterCardExpandStates[col.columnDef.header as string]
                }
                onExpandedChange={(val) => {
                  setFilterCardExpandStates({
                    ...filterCardExpandStates,
                    [col.columnDef.header as string]: val,
                  });
                }}
                from={
                  (col.getFilterValue() as any)?.value?.from
                    ? (col.getFilterValue() as any).value.from
                    : null
                }
                to={
                  (col.getFilterValue() as any)?.value?.to
                    ? (col.getFilterValue() as any).value.to
                    : null
                }
                onDelete={() => {
                  col.setFilterValue(null);
                }}
                onChange={(from, to) => {
                  if (from === null && to === null) {
                    col.setFilterValue(null);
                  }
                  col.setFilterValue({
                    value: {
                      from: from !== null ? from : undefined,
                      to: to !== null ? to : undefined,
                    },
                    filterType: col.columnDef.filterType,
                  });
                  return;
                }}
              />
            );
          case FilterType.ClosedStatus:
            return (
              <ClosedStatusFilterCard
                trueText={t(
                  `${entityType?.toUpperCase()}.CLOSED_STATUS.HIDE_CLOSED`
                )}
                falseText={t(
                  `${entityType?.toUpperCase()}.CLOSED_STATUS.SHOW_ALL`
                )}
                onExpandedChange={(val) => {
                  setFilterCardExpandStates({
                    ...filterCardExpandStates,
                    [label]: val,
                  });
                }}
                expanded={filterCardExpandStates[label]}
                value={(col.getFilterValue() as any)?.value ?? false}
                onChange={(value) => {
                  col.setFilterValue({
                    value,
                    filterType: FilterType.ClosedStatus,
                  });

                  setHideClosedEntitiesSetting(value);
                }}
                key={label}
                title={label}
              />
            );
          case FilterType.BooleanNumber:
          case FilterType.Boolean:
            return (
              <BooleanFilterCard
                onExpandedChange={(val) => {
                  setFilterCardExpandStates({
                    ...filterCardExpandStates,
                    [label]: val,
                  });
                }}
                expanded={filterCardExpandStates[label]}
                value={(col.getFilterValue() as any)?.value ?? ''}
                onChange={(value) => {
                  if (
                    value === null ||
                    (Array.isArray(value) && value.length === 0)
                  ) {
                    col.setFilterValue(null);
                  } else {
                    col.setFilterValue({
                      value: value,
                      filterType: col.columnDef.filterType,
                    });
                  }
                }}
                key={label}
                title={label}
              />
            );
          case FilterType.Search:
            return (
              <SearchFilterCard
                key={label}
                title={label}
                onExpandedChange={(val) => {
                  setFilterCardExpandStates({
                    ...filterCardExpandStates,
                    [label]: val,
                  });
                }}
                expanded={filterCardExpandStates[label]}
                onDelete={() => {
                  col.setFilterValue(null);
                }}
                value={(col.getFilterValue() as any)?.value ?? ''}
                onChange={(value) => {
                  const normalizedValue =
                    value.trim().length > 0 ? value : null;

                  // If the actual search string didn't change, don't update the
                  // filter to avoid unnesessary re-renders.
                  if (
                    (col.getFilterValue() == null &&
                      normalizedValue === null) ||
                    (col.getFilterValue() as any)?.value === normalizedValue
                  ) {
                    return;
                  }

                  col.setFilterValue(
                    normalizedValue !== null
                      ? {
                          value,
                          filterType: col.columnDef.filterType,
                        }
                      : null
                  );
                }}
              />
            );

          case FilterType.Picker:
            return renderPickerFilter(col);
          case FilterType.EmailKind:
          case FilterType.VacationKind:
          case FilterType.EInvoiceFormat:
          case FilterType.TicketStatus:
          case FilterType.AppointmentState:
          case FilterType.AppointmentBillable:
          case FilterType.TaskStatus:
          case FilterType.TravelReceiptStatus:
          case FilterType.SalesOpportunitiesStatusPicker:
          case FilterType.SalesOpportunitiesGroupPicker:
          case FilterType.PaymentStatus:
          case FilterType.InvoiceForm:
          case FilterType.ReAccountingStatus:
          case FilterType.RaAccountingStatus:
          case FilterType.PermitStatus:
          case FilterType.VacationStatus:
          case FilterType.InvoiceKind:
          case FilterType.LedgerAccountKind:
          case FilterType.DueDateClassified:
          case FilterType.ArticleKind:
          case FilterType.RythmStatus:
          case FilterType.TaskPriority:
          case FilterType.Enum:
          case FilterType.TicketPriority:
          case FilterType.ProjectTrafficLightStatus:
          case FilterType.TravelExpensesOpenStatus:
            return renderFixedDataFilterCard(
              col.columnDef.filterType,
              label,
              col
            );
          default:
            return null;
        }
      })}
    </div>
  );
};
